module.exports = __webpack_public_path__ + "static/img/consult.f854ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/consult/image/consult.png
// module id = /82Q
// module chunks = 6